
import ReactDOM, { Root } from 'react-dom/client';
import { createElement, ReactNode } from "react";
import ModalDialog from "./ModalDialog";
import style from "./Alert.module.css";
import { T, COMMON } from '../common/js/i18n';

interface MountRoot {
    container: HTMLElement;
    root: Root;
}

let mountRoot: MountRoot | null = null;

function Alert(props: {
    title: string;
    content: string;
    okText: string;
    onOk?: () => void;
    children?: ReactNode;
}) {
    return (
        <ModalDialog title={props.title} closable={false} centerStyle={{ 'minWidth': '24em', 'maxWidth': '36em' }}>
            <div style={{ "minHeight": "2em", "padding": "0.5em 1em" }}>
                <slot>{props.content}</slot>
            </div>
            <div style={{
                "textAlign": "center",
                'paddingBottom': '1em'
            }}>
                <button type="button" className={style["ok-btn"]} onClick={() => {
                    props.onOk && props.onOk();
                }} style={{ "fontSize": "inherit", "color": "#fff", "padding": "0.25em 1em", "borderRadius": "0.25em", "borderStyle": "none" }}>{props.okText || T(COMMON.OK)}</button>
            </div>
        </ModalDialog>
    );
}

export function show(content: string, title: string, okText: string) {
    if (!mountRoot) {
        const container = document.createElement("div");
        document.body.appendChild(container);
        const root = ReactDOM.createRoot(
            container as HTMLElement
        );
        mountRoot = {
            container: container,
            root: root
        };
        root.render(createElement(Alert, {
            title: title,
            content: content,
            okText: okText,
            onOk: () => {
                if (mountRoot) {
                    mountRoot.root.unmount();
                    document.body.removeChild(mountRoot.container);
                    mountRoot = null;
                }
            }
        }));
    }
}

export default Alert;